'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.getLatestMessage = exports.getErrorMessages = exports.getSuccessMessages = exports.getFlashMessages = exports.reducer = undefined;
var _handleActions;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _reduxActions = require('redux-actions');
var _actions = require('./actions');
var actions = _interopRequireWildcard(_actions);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
var initialState = {
  messages: []
};
var reducer = exports.reducer = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, actions.FLASH_MESSAGE_ACTION_TYPE, function () {
  throw new Error('redux-flash: missing middleware. Did you remember to add it when initializing your store?');
}), _defineProperty(_handleActions, actions._addMessage, function (state, _ref) {
  var payload = _ref.payload;
  var messages = [].concat(_toConsumableArray(state.messages), [payload]);
  return _extends({}, state, {
    messages: messages
  });
}), _defineProperty(_handleActions, actions.removeMessage, function (state, _ref2) {
  var id = _ref2.payload;
  var messages = state.messages.filter(function (m) {
    return m.id !== id;
  });
  return _extends({}, state, {
    messages: messages
  });
}), _defineProperty(_handleActions, actions.clearMessages, function (state) {
  return _extends({}, state, {
    messages: []
  });
}), _handleActions), initialState);
var getFlashMessages = exports.getFlashMessages = function getFlashMessages(state) {
  if (!state.flash) throw new Error('redux-flash: state not found. Did you remember to attach the reducer at key `flash`?');
  return [].concat(_toConsumableArray(state.flash.messages));
};
var getSuccessMessages = exports.getSuccessMessages = function getSuccessMessages(state) {
  return getFlashMessages(state).filter(function (m) {
    return !m.isError;
  });
};
var getErrorMessages = exports.getErrorMessages = function getErrorMessages(state) {
  return getFlashMessages(state).filter(function (m) {
    return m.isError;
  });
};
var getLatestMessage = exports.getLatestMessage = function getLatestMessage(state) {
  return getFlashMessages(state).pop();
};